import { Injectable } from '@angular/core';
import { StorageStrategy } from '../storage-strategy.interface';

/**
 * Implementation of StorageStrategy using localStorage.
 * This is the default storage strategy that persists data across browser sessions.
 */
@Injectable({
  providedIn: 'root',
})
export class LocalStorageStrategy implements StorageStrategy {
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  getAllKeys(): string[] {
    try {
      const keys: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key) {
          keys.push(key);
        }
      }
      return keys;
    } catch (e) {
      console.error('Failed to get all keys from localStorage:', e);
      return [];
    }
  }
}
